module.exports = __webpack_public_path__ + "img/microphoneWhite.e588ebb4.svg";